// extracted by mini-css-extract-plugin
export var button_icon = "ContactPopup-module--button_icon--cee79";
export var desktop_caption = "ContactPopup-module--desktop_caption--56e7e";
export var desktop_content = "ContactPopup-module--desktop_content--975a0";
export var desktop_cta = "ContactPopup-module--desktop_cta--bf2fa";
export var desktop_floating = "ContactPopup-module--desktop_floating--afcca";
export var desktop_image = "ContactPopup-module--desktop_image--dce66";
export var desktop_text = "ContactPopup-module--desktop_text--54f91";
export var desktop_title = "ContactPopup-module--desktop_title--2bffe";
export var floating_container = "ContactPopup-module--floating_container--782d8";
export var floating_label = "ContactPopup-module--floating_label--8be68";
export var input_email = "ContactPopup-module--input_email--799ff";
export var input_name = "ContactPopup-module--input_name--9e5af";
export var send_mail = "ContactPopup-module--send_mail--bb90e";